import { z } from '../utils/zod-extend'
import { idSchema, isoStringDatetimeSchema } from './id.type'

const CALENDAR_DAYS = [
  '',
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
] as const

export type CalendarDay = typeof CALENDAR_DAYS[number]

const calendarAnswerSchema = z.object({
  id: idSchema,
  surveyName: z.string().nullable(),
  createdAt: isoStringDatetimeSchema,
})

export const getCalendarAnswerCountsQuerySchema = z.object({
  year: z.coerce.number().min(1970).max(9999),
  month: z.coerce.number().min(1).max(12),
}).openapi('GetCalendarAnswerCountsQuery')
export type GetCalendarAnswerCountsQuery = z.infer<typeof getCalendarAnswerCountsQuerySchema>

export const getCalendarAnswerCountsResponseSchema = z.object({
  groups: z.array(z.object({
    createdAt: z.string().date(),
    value: z.number(),
  })),
}).openapi('GetCalendarAnswerCountsResponse')
export type GetCalendarAnswerCountsResponse = z.infer<typeof getCalendarAnswerCountsResponseSchema>

export const getDateAnswersQuerySchema = z.object({
  date: z.string().date(),
}).openapi('GetDateAnswersQuery')
export type GetDateAnswersQuery = z.infer<typeof getDateAnswersQuerySchema>

export const getDateAnswersResponseSchema = z.object({
  items: z.array(calendarAnswerSchema),
}).openapi('GetDateAnswersResponse')
export type GetDateAnswersResponse = z.infer<typeof getDateAnswersResponseSchema>

export const getOldestAnswerDateQuerySchema = z.object({}).openapi('GetOldestAnswerDateQuery')
export type GetOldestAnswerDateQuery = z.infer<typeof getCalendarAnswerCountsQuerySchema>

export const getOldestAnswerDateResponseSchema = z.object({
  oldestAnswerDate: z.string().date().nullable(),
}).openapi('GetOldestAnswerDateResponse')
export type GetOldestAnswerDateResponse = z.infer<typeof getOldestAnswerDateResponseSchema>

export type YearMonth = {
  year: number
  month: number // 1 ~ 12
}

export type DayCount = {
  day: CalendarDay
  count: number
}

export type DateAnswers = z.infer<typeof calendarAnswerSchema>[]

export type DateAnswersMap = {
  [date: string]: DateAnswers
}
